import React from 'react';
import { cn } from '../../utils/cn';

const Progress = React.forwardRef(({
  className,
  value = 0,
  max = 100,
  size = 'md',
  variant = 'default',
  showValue = false,
  ...props
}, ref) => {
  const percentage = Math.min(Math.max((value / max) * 100, 0), 100);
  
  const sizeClasses = {
    sm: 'h-2',
    md: 'h-3',
    lg: 'h-4',
  };
  
  const variantClasses = {
    default: 'bg-primary-500',
    success: 'bg-green-500',
    warning: 'bg-yellow-500',
    destructive: 'bg-red-500',
  };
  
  const baseClasses = 'relative w-full overflow-hidden rounded-full bg-gray-200 dark:bg-gray-700';
  const sizeClass = sizeClasses[size];
  const variantClass = variantClasses[variant];
  
  const classes = cn(
    baseClasses,
    sizeClass,
    className
  );

  return (
    <div className="w-full">
      <div
        ref={ref}
        className={classes}
        role="progressbar"
        aria-valuenow={value}
        aria-valuemin={0}
        aria-valuemax={max}
        {...props}
      >
        <div
          className={cn('h-full transition-all duration-300 ease-in-out', variantClass)}
          style={{ width: `${percentage}%` }}
        />
      </div>
      {showValue && (
        <div className="mt-1 text-sm text-gray-600 dark:text-gray-400 text-center">
          {Math.round(percentage)}%
        </div>
      )}
    </div>
  );
});

Progress.displayName = 'Progress';

export { Progress };
